import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DynamicMenu from './DynamicMenu';
import configData from '../../configData.json';
import { getMenuItems, setMenuItems } from './menuStorage';

export default function DesktopMenu() {
  const baseUrl = 'https://example.com';
  const [formattedMenuItems, setFormattedMenuItems] = useState(getMenuItems());
  const [hasHelpItem, setHasHelpItem] = useState(false);

  // useEffect(() => {
  //   if (formattedMenuItems.length === 0) {
  //     fetchData();
  //   }
  // }, []);

  useEffect(() => {
    if (formattedMenuItems.length > 0) {
      const helpItemExists = formattedMenuItems.some((item) => item.name === 'Help');
      setHasHelpItem(helpItemExists);
    }
  }, [formattedMenuItems]);

  const fetchData = async () => {
    let email = sessionStorage.getItem('my-emailid');
    const menuUrl = `${configData.BASE_APP_URL}Login/GetMenus/${email}`;

    try {
      const resp = await fetch(menuUrl, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          Authorization: sessionStorage.getItem('my-token'),
        },
      });
      const parsedResp = await resp.json();

      const menuItems = parsedResp.map((item) => ({
        name: item.label,
        isdisabled: false,
        isActive: item.id === 1,
        href: `../${item.formName}`,
        id: item.id,
        menuIcon: item.menuIcon,
      }));

      setFormattedMenuItems(menuItems);
    } catch (error) {
      // Handle any errors that occur during the fetch or parsing process
      console.error('An error occurred:', error);
    }
  };

  const filteredMenuItems = formattedMenuItems.filter((item) => item.name !== 'Help');

  return (
    <>
      <div>
        <DynamicMenu
          items={filteredMenuItems}
          navClassName="navbar-nav"
          navItemClassName="top_menu nav-link"
          navItemActiveClassName="active-nav nav-link"
        />
        {/* Additional code */}
        {hasHelpItem && (
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                href="https://datadash.nvisionglobal.com/HelpFile/Global Freight Invoice Processing Data Dashboard.pdf"
                className="top_menu nav-link"
                target="_blank"
              >
                <i className="far fa-question-circle"></i> Help
              </a>
            </li>
          </ul>
        )}
      </div>
    </>
  );
}
